import { DatePicker, Form } from 'antd';
import { CloseOutlined, SearchOutlined } from '@ant-design/icons';
import React from 'react';
import CustomButton from 'components/custom-button';
import moment from 'moment';

const { RangePicker } = DatePicker;

const initialValues = {
  datePicker: [],
};

const Filter: React.FC<any> = (props) => {
  const [form] = Form.useForm();
  const { onSubmit } = props;

  const onClearFilter = () => {
    form.resetFields();
    onSubmit({ ...form.getFieldsValue(), startDate: '', endDate: '' });
  };

  const onFormSubmit = (value: typeof initialValues) => {
    const { datePicker } = value;
    let startDate = '';
    let endDate = '';

    if (datePicker) {
      const [start, end] = datePicker as moment.Moment[];

      startDate = start?.format('YYYY-MM-DD');
      endDate = end?.format('YYYY-MM-DD');
    }

    onSubmit({ startDate, endDate });
  };

  return (
    <Form
      form={form}
      name="register"
      layout="inline"
      onFinish={onFormSubmit}
      initialValues={initialValues}
      style={{ rowGap: 12 }}
    >
      <Form.Item label="Ngày PK" name="datePicker">
        <RangePicker placeholder={['Từ ngày', 'Đến ngày']} />
      </Form.Item>
      <Form.Item>
        <CustomButton
          bgColor="secondary-green"
          htmlType="submit"
          text="Tìm kiếm"
          icon={<SearchOutlined />}
        />
      </Form.Item>
      <Form.Item>
        <CustomButton
          text="Xóa lọc"
          bgColor="primary-grey"
          icon={<CloseOutlined />}
          onClick={onClearFilter}
        />
      </Form.Item>
    </Form>
  );
};

export default Filter;
